import { useEffect, useState } from 'react';
import { STORAGE } from "../storage";
import { initSoketiBookingInterval, stopSoketiBookingInterval, isSoketiBookingIntervalRunning } from "../soketi/soketiBookingInterval";
import { isSoketiConnected } from "../soketi";

const useSoketiBookingInterval = () => {
    const [isSoketiActive, setIsSoketiActive] = useState(false);

    // Check if Soketi is active on mount
    useEffect(() => {
        const checkSoketiStatus = async () => {
            const soketiUrl = await STORAGE.get("soketiUrl");
            setIsSoketiActive(!!soketiUrl);
        };
        checkSoketiStatus();
    }, []);

    // Manage the Soketi booking interval lifecycle
    useEffect(() => {
        if (!isSoketiActive) {
            if (isSoketiBookingIntervalRunning()) {
                stopSoketiBookingInterval();
            }

            return;
        }

        if (isSoketiConnected() && !isSoketiBookingIntervalRunning()) {
            initSoketiBookingInterval();
        }

        // Cleanup function to stop the interval when component unmounts
        return () => {
            if (isSoketiBookingIntervalRunning()) {
                stopSoketiBookingInterval();
            }
        };
    }, [isSoketiActive]);

    return null;
};

export default useSoketiBookingInterval;
